import { LoadingIndicator } from "@/shared/components/LoadingIndicator";
import { lazyLoad } from "@/shared/utils/loadable";

/** See landing/loadable.tsx — same `heroBleed` + light-header consideration. */
const Fallback = () => (
  <>
    <div aria-hidden className="h-[var(--kf-header-h)] w-full bg-kf-ink" />
    <LoadingIndicator fullPageHeight />
  </>
);

export const ParcelDetailPage = lazyLoad(
  () => import("./index"),
  (module) => module.default,
  { fallback: <Fallback /> }
);
